import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, vModelText as _vModelText, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = { class: "row g-2 ps-3" }
const _hoisted_3 = { class: "cursor-pointer w-100 h-100" }
const _hoisted_4 = ["value"]
const _hoisted_5 = {
  key: 0,
  class: "position-absolute top-0 end-0 m-1",
  style: {"font-size":"0.7rem"}
}
const _hoisted_6 = {
  class: "fw-bold text-uppercase mt-1",
  style: {"font-size":"0.7rem"}
}
const _hoisted_7 = { class: "mt-3 ps-3" }
const _hoisted_8 = { class: "row g-2 mb-3" }
const _hoisted_9 = { class: "col-md-6" }
const _hoisted_10 = { class: "input-group input-group-sm shadow-sm" }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "form-check form-switch" }
const _hoisted_13 = { class: "mb-5" }
const _hoisted_14 = { class: "d-flex align-items-center justify-content-between mb-3" }
const _hoisted_15 = { class: "form-check form-switch custom-switch-md" }
const _hoisted_16 = {
  key: 0,
  class: "overflow-hidden ps-3"
}
const _hoisted_17 = {
  key: 0,
  class: "bg-white rounded-3 p-3 border mb-2"
}
const _hoisted_18 = { class: "mb-3" }
const _hoisted_19 = { class: "row g-2" }
const _hoisted_20 = { class: "col-md-6" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = {
  key: 0,
  value: "",
  disabled: ""
}
const _hoisted_23 = ["value"]
const _hoisted_24 = {
  key: 0,
  class: "alert alert-info py-1 px-2 small mt-2",
  style: {"font-size":"0.75rem"}
}
const _hoisted_25 = {
  key: 1,
  class: "alert alert-warning py-1 px-2 small mt-2",
  style: {"font-size":"0.75rem"}
}
const _hoisted_26 = { class: "col-md-3" }
const _hoisted_27 = { class: "input-group input-group-sm shadow-sm" }
const _hoisted_28 = { class: "col-md-3" }
const _hoisted_29 = { class: "d-flex gap-3" }
const _hoisted_30 = { class: "form-check form-switch" }
const _hoisted_31 = { class: "form-check form-switch" }
const _hoisted_32 = { class: "row g-2 mt-2" }
const _hoisted_33 = { class: "col-md-6" }
const _hoisted_34 = { class: "input-group input-group-sm shadow-sm" }
const _hoisted_35 = { class: "col-md-6" }
const _hoisted_36 = { class: "form-check form-switch" }
const _hoisted_37 = {
  key: 0,
  class: "text-muted small ms-3 ps-3 border-start border-3"
}

import { reactive, watch, PropType, onMounted, ref, computed } from "vue";
import { useStore } from "vuex";
import type { TelegramChannel } from "@/stores/telegramChannels";
import type { Rank } from "@/store/Ranks/RanksInterfaces";
import {
  normalizeStoredPackageLabel,
  PKG_FLY,
  PKG_GO,
  PKG_WIN,
} from "functions/src/Subscriptions/packageIds";
// El color, el icono y el nombre comercial de cada paquete se preguntan a la
// fuente única. Este formulario los tenía en tres `switch` propios y con un
// defecto de bulto: el CMMI compartía el amarillo de WIN.
import PackageIcon from "@/components/common/PackageIcon.vue";
import {
  productVisual,
  productVisualId,
} from "@/components/common/productVisuals";
import {
  DEFAULT_MONITORING_CONFIG,
  useChannelsStore,
} from "@/stores/telegramChannels";
import ChannelBasicInfo from "./ChannelBasicInfo.vue";
import ChannelKickConfig from "./ChannelKickConfig.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ServiceChannelForm',
  props: {
  modelValue: {
    type: Object as PropType<TelegramChannel>,
    required: true,
  },
  isEditing: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:modelValue", "validation"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;
const store = useChannelsStore();
const vuexStore = useStore();

const formData = reactive<TelegramChannel>({ ...props.modelValue });

// 🔴 `availableForPackage` DECIDE ACCESOS Y ES DATO GUARDADO. Hay canales cuya
// lista quedó escrita con la etiqueta retirada. Si el formulario la cargara tal
// cual, sus casillas saldrían DESMARCADAS —el checkbox compara contra las
// etiquetas vivas— y el primer guardado dejaría al canal sin ningún paquete: la
// gente que ya pagaba lo perdería sin que nadie tocara esa casilla. Se traduce
// al cargar; lo que no se reconoce se conserva intacto, para no tirar una
// entrada que alguien puso a mano y aquí no entendemos.
formData.availableForPackage = (formData.availableForPackage || []).map(
  (pkg) => normalizeStoredPackageLabel(pkg) || pkg
);

const availablePackages = [PKG_GO, PKG_FLY, PKG_WIN];

// Ranks
const availableRanks = computed<Rank[]>(() => {
  const ranksGetter = vuexStore.getters["ranks/allRanks"];
  const ranksMap =
    typeof ranksGetter === "function" ? ranksGetter() : ranksGetter;
  return ranksMap ? Array.from(ranksMap.values()) : [];
});

// Use models from store
const availableModels = computed(() => store.availableAIModels);
const isLoadingModels = ref(false);

// Computed property to convert confidence threshold between 0-1 and 0-100
const confidencePercent = computed({
  get: () =>
    Math.round((formData.monitoringConfig?.confidenceThreshold || 0) * 100),
  set: (value: number) => {
    if (formData.monitoringConfig) {
      formData.monitoringConfig.confidenceThreshold = value / 100;
    }
  },
});

// LA VARIANTE SUAVE DEL COLOR DEL PRODUCTO, PARA LA TARJETA MARCADA.
//
// `productVisualId` traduce cualquier id —vivo, retirado o de licencia— a la
// llave con la que se pinta, y de ahí sale el nombre de la clase. Se compone
// aquí y no en la plantilla porque el nombre de la utilidad es un detalle de la
// hoja de estilos: si algún día `pkg-subtle-…` se llama de otra forma, se
// cambia en esta línea y no en cada `:class`.
//
// 🔴 DE PASO SE ARREGLA EL CMMI. El `switch` que había mandaba `mmi-*` a
// `bg-warning-subtle`, que era el mismo amarillo que WIN: dos productos que no
// tienen nada que ver salían idénticos. Ahora cae en `unknown`, el gris
// neutro, que es lo honesto para algo que no es un escalón de la escalera.
// (En la práctica no se ve: `availablePackages` sólo lleva los tres niveles.)
const packageSelectedClass = (pkg: string) =>
  `pkg-subtle-${productVisualId(pkg)}`;

const getModelEmoji = (model: string) => {
  const m = model.toLowerCase();
  if (m.includes("lite")) return "💨"; // Lite - lightweight/fast
  if (m.includes("flash")) {
    if (m.includes("image")) return "🖼️"; // Flash Image
    return "⚡"; // Flash - speed
  }
  if (m.includes("pro")) return "⭐"; // Pro - premium
  if (m.includes("image")) return "🖼️"; // Image/Vision
  return "🤖"; // Default
};

const formatDate = (date: Date | null) => {
  if (!date) return "N/A";
  return new Intl.DateTimeFormat("es-ES", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(date);
};

// Sync back to parent
watch(
  formData,
  (newVal) => {
    emit("update:modelValue", newVal);
    validate();
  },
  { deep: true }
);

// Validation logic
const validate = () => {
  const errors: string[] = [];
  if (!formData.id) errors.push("El ID de Telegram es requerido");
  if (!formData.name) errors.push("El nombre del canal es requerido");

  if (formData.monitoringEnabled) {
    if (!formData.alertsType) errors.push("El tipo de alertas es requerido");
  }

  emit("validation", errors);
};

// Initial validation
onMounted(async () => {
  // If new, ensure monitoring config exists
  if (!formData.monitoringConfig) {
    formData.monitoringConfig = { ...DEFAULT_MONITORING_CONFIG };
  }
  validate();

  // Load models from store
  if (store.availableAIModels.length === 0) {
    isLoadingModels.value = true;
    await store.fetchAIModels();
    isLoadingModels.value = false;
  }

  // Load ranks
  vuexStore.dispatch("ranks/doGetRanksInfo");
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(ChannelBasicInfo, {
      id: formData.id,
      "onUpdate:id": _cache[0] || (_cache[0] = ($event: any) => ((formData.id) = $event)),
      name: formData.name,
      "onUpdate:name": _cache[1] || (_cache[1] = ($event: any) => ((formData.name) = $event)),
      priority: formData.priority,
      "onUpdate:priority": _cache[2] || (_cache[2] = ($event: any) => ((formData.priority) = $event)),
      active: formData.active,
      "onUpdate:active": _cache[3] || (_cache[3] = ($event: any) => ((formData.active) = $event)),
      "disabled-id": __props.isEditing
    }, null, 8, ["id", "name", "priority", "active", "disabled-id"]),
    _cache[41] || (_cache[41] = _createElementVNode("hr", { class: "my-3 text-muted opacity-25" }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _cache[25] || (_cache[25] = _createElementVNode("h6", { class: "fw-bold text-dark mb-2" }, [
        _createElementVNode("i", { class: "fas fa-box fa-fw me-2 text-info" }),
        _createTextVNode("Disponible para ")
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(availablePackages, (pkg) => {
          return _createElementVNode("div", {
            class: "col-4",
            key: pkg
          }, [
            _createElementVNode("label", _hoisted_3, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.availableForPackage) = $event)),
                type: "checkbox",
                value: pkg,
                class: "d-none peer"
              }, null, 8, _hoisted_4), [
                [_vModelCheckbox, formData.availableForPackage]
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["p-2 rounded-3 border h-100 text-center transition-all position-relative selection-card d-flex flex-column align-items-center justify-content-center", 
                formData.availableForPackage.includes(pkg)
                  ? packageSelectedClass(pkg) + ' shadow-sm'
                  : 'bg-light border text-muted opacity-50 grayscale'
              ]),
                style: {"transition":"all 0.2s ease-in-out"}
              }, [
                (formData.availableForPackage.includes(pkg))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[18] || (_cache[18] = [
                      _createElementVNode("i", { class: "fas fa-check-circle" }, null, -1)
                    ]))]))
                  : _createCommentVNode("", true),
                _createVNode(PackageIcon, {
                  product: pkg,
                  "extra-class": 
                  [
                    'fa-xl mb-1 mt-1',
                    formData.availableForPackage.includes(pkg)
                      ? ''
                      : 'text-muted',
                  ].join(' ')
                
                }, null, 8, ["product", "extra-class"]),
                _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(productVisual)(pkg).label), 1)
              ], 2)
            ])
          ])
        }), 64))
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _cache[21] || (_cache[21] = _createElementVNode("label", { class: "form-label text-muted small fw-bold mb-1" }, " Rango Auto Admin (Opcional) ", -1)),
            _createElementVNode("div", _hoisted_10, [
              _cache[20] || (_cache[20] = _createElementVNode("span", { class: "input-group-text bg-white border-end-0 text-muted" }, [
                _createElementVNode("i", { class: "fas fa-crown" })
              ], -1)),
              _withDirectives(_createElementVNode("select", {
                class: "form-select bg-white border-start-0",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.minAdminRank) = $event)),
                style: {"border-left":"0"}
              }, [
                _cache[19] || (_cache[19] = _createElementVNode("option", { value: "" }, "-- N/A --", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableRanks.value, (rank) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: rank._id,
                    value: rank._id
                  }, _toDisplayString(rank.name), 9, _hoisted_11))
                }), 128))
              ], 512), [
                [_vModelSelect, formData.minAdminRank]
              ])
            ]),
            _cache[22] || (_cache[22] = _createElementVNode("small", {
              class: "text-muted small mt-1 d-block",
              style: {"font-size":"0.65rem"}
            }, " Promoción automática a administrador si el usuario tiene este rango. ", -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _withDirectives(_createElementVNode("input", {
            class: "form-check-input cursor-pointer",
            type: "checkbox",
            id: "visibleWhenRestrictedSwitch",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.visibleWhenRestricted) = $event))
          }, null, 512), [
            [_vModelCheckbox, formData.visibleWhenRestricted]
          ]),
          _cache[23] || (_cache[23] = _createElementVNode("label", {
            class: "form-check-label cursor-pointer text-dark small fw-medium",
            for: "visibleWhenRestrictedSwitch"
          }, " Mostrar como Bloqueado si no tiene acceso ", -1))
        ]),
        _cache[24] || (_cache[24] = _createElementVNode("small", {
          class: "text-muted small ps-2 d-block",
          style: {"font-size":"0.7rem"}
        }, " Si se activa, el canal aparecerá con un candado 🔒 para los usuarios que no tengan el paquete necesario. De lo contrario, se ocultará por completo. ", -1))
      ])
    ]),
    _cache[42] || (_cache[42] = _createElementVNode("hr", { class: "my-3 text-muted opacity-25" }, null, -1)),
    _createVNode(ChannelKickConfig, {
      kickUsers: formData.kickUsers,
      "onUpdate:kickUsers": _cache[7] || (_cache[7] = ($event: any) => ((formData.kickUsers) = $event)),
      kickAfter: formData.kickAfter,
      "onUpdate:kickAfter": _cache[8] || (_cache[8] = ($event: any) => ((formData.kickAfter) = $event)),
      kickAfterUnit: formData.kickAfterUnit,
      "onUpdate:kickAfterUnit": _cache[9] || (_cache[9] = ($event: any) => ((formData.kickAfterUnit) = $event))
    }, null, 8, ["kickUsers", "kickAfter", "kickAfterUnit"]),
    _cache[43] || (_cache[43] = _createElementVNode("hr", { class: "my-3 text-muted opacity-25" }, null, -1)),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _cache[26] || (_cache[26] = _createElementVNode("h6", { class: "fw-bold text-dark mb-0" }, [
          _createElementVNode("i", { class: "fas fa-robot fa-fw me-2" }),
          _createTextVNode("IA Monitoring ")
        ], -1)),
        _createElementVNode("div", _hoisted_15, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.monitoringEnabled) = $event)),
            class: "form-check-input cursor-pointer success",
            type: "checkbox",
            id: "monitoringSwitch"
          }, null, 512), [
            [_vModelCheckbox, formData.monitoringEnabled]
          ])
        ])
      ]),
      _createVNode(_Transition, { name: "expand" }, {
        default: _withCtx(() => [
          (formData.monitoringEnabled)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                (formData.monitoringConfig)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _cache[28] || (_cache[28] = _createElementVNode("label", { class: "form-label text-muted small fw-bold mb-1" }, [
                          _createTextVNode(" Tipo de Alertas "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.alertsType) = $event)),
                          class: "form-select form-select-sm bg-white shadow-sm",
                          required: ""
                        }, [...(_cache[27] || (_cache[27] = [
                          _createElementVNode("option", { value: "" }, "Seleccionar tipo...", -1),
                          _createElementVNode("option", { value: "sports_betting" }, "⚽ Apuestas Deportivas", -1),
                          _createElementVNode("option", { value: "forex" }, "📈 Forex", -1),
                          _createElementVNode("option", { value: "synthetic_indices" }, "📊 Índices Sintéticos", -1)
                        ]))], 512), [
                          [_vModelSelect, formData.alertsType]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _cache[31] || (_cache[31] = _createElementVNode("label", { class: "form-label text-muted small fw-bold mb-1" }, [
                            _createTextVNode(" Modelo de IA "),
                            _createElementVNode("span", { class: "text-danger" }, "*")
                          ], -1)),
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formData.monitoringConfig.aiModel) = $event)),
                            class: "form-select form-select-sm bg-white shadow-sm",
                            disabled: isLoadingModels.value
                          }, [
                            (isLoadingModels.value)
                              ? (_openBlock(), _createElementBlock("option", _hoisted_22, " Cargando modelos... "))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableModels.value, (model) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: model,
                                value: model
                              }, _toDisplayString(getModelEmoji(model)) + " " + _toDisplayString(model), 9, _hoisted_23))
                            }), 128))
                          ], 8, _hoisted_21), [
                            [_vModelSelect, formData.monitoringConfig.aiModel]
                          ]),
                          (_unref(store).aiModelsIsHardcoded)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [...(_cache[29] || (_cache[29] = [
                                _createElementVNode("i", { class: "fas fa-info-circle me-1" }, null, -1),
                                _createTextVNode(" Usando lista predeterminada (emulador) ", -1)
                              ]))]))
                            : (_unref(store).aiModelsIsStale && _unref(store).aiModelsLastUpdated)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                  _cache[30] || (_cache[30] = _createElementVNode("i", { class: "fas fa-exclamation-triangle me-1" }, null, -1)),
                                  _createTextVNode(" No se pudo actualizar la lista. Última actualización: " + _toDisplayString(formatDate(_unref(store).aiModelsLastUpdated)), 1)
                                ]))
                              : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                          _cache[33] || (_cache[33] = _createElementVNode("label", { class: "form-label text-muted small fw-bold mb-1" }, [
                            _createTextVNode(" Confianza Mínima "),
                            _createElementVNode("span", { class: "text-danger" }, "*")
                          ], -1)),
                          _createElementVNode("div", _hoisted_27, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((confidencePercent).value = $event)),
                              type: "number",
                              class: "form-control bg-white text-center",
                              min: "0",
                              max: "100",
                              step: "5"
                            }, null, 512), [
                              [
                                _vModelText,
                                confidencePercent.value,
                                void 0,
                                { number: true }
                              ]
                            ]),
                            _cache[32] || (_cache[32] = _createElementVNode("span", { class: "input-group-text bg-white text-muted" }, "%", -1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_28, [
                          _cache[36] || (_cache[36] = _createElementVNode("label", { class: "form-label text-muted small fw-bold mb-2" }, "Procesar", -1)),
                          _createElementVNode("div", _hoisted_29, [
                            _createElementVNode("div", _hoisted_30, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((formData.monitoringConfig.processImages) = $event)),
                                class: "form-check-input cursor-pointer success",
                                type: "checkbox",
                                id: "processImagesSwitch"
                              }, null, 512), [
                                [_vModelCheckbox, formData.monitoringConfig.processImages]
                              ]),
                              _cache[34] || (_cache[34] = _createElementVNode("label", {
                                class: "form-check-label cursor-pointer small",
                                for: "processImagesSwitch"
                              }, " 🖼️ ", -1))
                            ]),
                            _createElementVNode("div", _hoisted_31, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((formData.monitoringConfig.processVideos) = $event)),
                                class: "form-check-input cursor-pointer success",
                                type: "checkbox",
                                id: "processVideosSwitch"
                              }, null, 512), [
                                [_vModelCheckbox, formData.monitoringConfig.processVideos]
                              ]),
                              _cache[35] || (_cache[35] = _createElementVNode("label", {
                                class: "form-check-label cursor-pointer small",
                                for: "processVideosSwitch"
                              }, " 🎥 ", -1))
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                          _cache[38] || (_cache[38] = _createElementVNode("label", { class: "form-label text-muted small fw-bold mb-1" }, [
                            _createTextVNode(" Duración del Caché "),
                            _createElementVNode("span", { class: "text-danger" }, "*")
                          ], -1)),
                          _createElementVNode("div", _hoisted_34, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((
                      formData.monitoringConfig.messagesCacheDuration
                    ) = $event)),
                              type: "number",
                              class: "form-control bg-white text-center",
                              min: "1",
                              step: "1"
                            }, null, 512), [
                              [
                                _vModelText,
                                
                      formData.monitoringConfig.messagesCacheDuration
                    ,
                                void 0,
                                { number: true }
                              ]
                            ]),
                            _cache[37] || (_cache[37] = _createElementVNode("span", { class: "input-group-text bg-white text-muted" }, "días", -1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_35, [
                          _cache[40] || (_cache[40] = _createElementVNode("label", { class: "form-label text-muted small fw-bold mb-2" }, " Exportación ", -1)),
                          _createElementVNode("div", _hoisted_36, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((formData.monitoringConfig.autoExportToBigQuery) = $event)),
                              class: "form-check-input cursor-pointer success",
                              type: "checkbox",
                              id: "autoExportSwitch"
                            }, null, 512), [
                              [_vModelCheckbox, formData.monitoringConfig.autoExportToBigQuery]
                            ]),
                            _cache[39] || (_cache[39] = _createElementVNode("label", {
                              class: "form-check-label cursor-pointer small",
                              for: "autoExportSwitch"
                            }, " 📊 Exportar a BigQuery ", -1))
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (!formData.monitoringEnabled)
            ? (_openBlock(), _createElementBlock("div", _hoisted_37, " El monitoreo IA permite analizar automáticamente las alertas enviadas al canal. Actívalo para configurar. "))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})